import Footer from 'src/components/Footer'
import Header from 'src/components/Header'
import NextBreadcrumb from '../NextBreadcrumb'

export function DetailNewsLayout({ hideBreadcrumb, children }) {
	return (
		<>
			<Header />
			<div className="container">
				<NextBreadcrumb rootLabel={'Trang chủ'} extraPartial="Chi tiết" />
			</div>
			<div>{children}</div>
			<Footer />
		</>
	)
}

export default DetailNewsLayout
